import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { ADMIN_ROUTES, EXCEPTION_CODE, STATUS } from '../../../../utils/constant';
import { makeRoute } from '../../../../utils/helper';
import { useSnackbar } from '../../../../hooks/useSnackBar';
import { HTTP_STATUS } from '../../../../utils/types';
import { ServicePayload, useVASMasterCategoryService } from '../../../../services/useVASMasterCategoryService';
import MainServiceViewTemplate from '../../../templates/VASMaster/Categories/MainServiceView.template';

interface MainServiceViewPageProps {
    mode: string
    service: any
}

const validationSchema = Yup.object().shape({
    name: Yup.string().max(30, "Main Service Name cannot be more than 30 characters").required("Main Service Name is required"),
    description: Yup.string().max(500, "Description cannot be more than 500 characters").required("Description is required"),
    parentId: Yup.number().required("Super Service is required"),
    superService: Yup.object().shape({
        id: Yup.number().required('Super Service is required'),
        label: Yup.string().required('Super Service is required')
    }).required('Super Service is required'),
});

const MainServiceViewPage: React.FC<MainServiceViewPageProps> = ({ mode, service }) => {
    const { showSnackbar, SnackBarComponent } = useSnackbar();
    const vasMasterCategoryService = useVASMasterCategoryService();
    const navigate = useNavigate();
    const params = useParams();

    const serviceId = Number(params.id);

    const onBack = () => {
        navigate(makeRoute(ADMIN_ROUTES.VAS_MASTER_CATEGORIES_LIST, { query: { type: 'MAIN_SERVICE' } }));
    }

    const updateMainService = async (service: ServicePayload) => {
        vasMasterCategoryService.updateCategory(serviceId, service)
            .then(res => {
                if (res.status === HTTP_STATUS.OK) {
                    showSnackbar('success', "Status Updated");
                    onBack();
                } else if (res.data.exceptionCode === EXCEPTION_CODE.DUPLICATE_ENTRY) {
                    showSnackbar('error', "Main Service already exists. Please try again");
                }
            }).catch((error) => {
                showSnackbar('error', "Failed to update Main Service");
            })
    }

    const formik = useFormik<ServicePayload>({
        initialValues: {
            name: service.name ?? "",
            status: service.status ?? STATUS.INACTIVE,
            serviceCode: service?.serviceCode ?? "",
            description: service?.description ?? "",
            parentId: service?.parentId ?? null,
            level: 1,
            superService: { label: service?.ancestors?.parentService?.name, id: service.ancestors?.parentService?.id },
        },
        validationSchema,
        onSubmit: async (values) => {
            updateMainService({ ...values, status: values.status })
        }
    })

    return (
        <div>
            {SnackBarComponent}
            <MainServiceViewTemplate mode={mode} onBack={onBack} formik={formik} />
        </div>
    )
}

export default MainServiceViewPage